import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

// Empty means "UE has not told us yet" — the element keeps the cursor the
// browser gives it. Only a reported state ever writes a value, so a build with
// the CURSOR_STATE_UE flag off behaves exactly as it did before MV-1820.
const initialState: IInitialState = {
  cursor: '',
};

/**
 * Cursor UE asks for over the stream (MV-1820).
 *
 * Lives in a store rather than in a provider because the video element is a
 * sibling of `MytaverseEventProvider` in `EventPageContainer`, so the websocket
 * handler that receives the state and the element that displays it are in two
 * separate React trees.
 */
export const useGamecastCursor = create<IContextState>((set) => ({
  ...initialState,
  setCursor: (cursor) => set({ cursor }),
  resetState: () => set(initialState),
}));
